import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'inspekt-form-page-template',
    templateUrl: 'form-page-template.component.html',
    imports: [CommonModule]
})

export class FormPageTemplateComponent {
    readonly leftContentWidth = input('col-sm-6');
    readonly rightContentWidth = input('col-sm-6');
}
